import React, { FC, useEffect, useMemo, useState } from "react";
import { Image } from "@tarojs/components";
import { getImageInfo } from "@tarojs/taro";
import classNames from "classnames";

import { pxTransform } from "../../utils/index";
import "./index.scss";
import { XHComponentCommonProps } from "../../types";

export type ImageProps = {
  width?: number;
  height?: number;
  src: string;
  alt?: string;
  style?: React.CSSProperties;
  dataTrackId?: string;
} & XHComponentCommonProps;

const XHImage: FC<ImageProps> = props => {
  const { width = 0, height = 0, src, className, dataTrackId, ...rest } = props;
  const [defaultSize, setDefaultSize] = useState<{
    width?: number;
    height?: number;
  }>({});

  useEffect(() => {
    if (process.env.TARO_ENV !== "h5" && !className) {
      getImageInfo({
        src,
        success: res => {
          if (res.errMsg === "getImageInfo:ok") {
            console.log(res);
            setDefaultSize({ width: res.width, height: res.height });
          }
        },
      });
    }
  }, []);

  const size = useMemo(() => {
    let computedSize: { width?: string | number; height?: string | number } =
      defaultSize || {};
    if (width) {
      computedSize.width = `${pxTransform(width)}`;
    }
    if (height) {
      computedSize.height = `${pxTransform(height)}`;
    }

    return computedSize;
  }, [width, height, defaultSize]);

  const imgCls = classNames("xh-image", className, dataTrackId);

  return process.env.TARO_ENV !== "h5" ? (
    <Image
      src={src}
      style={{ ...size, ...rest }}
      className={imgCls}
      // @ts-ignore
      dataTrackId={dataTrackId}
    />
  ) : (
    <img
      src={src}
      style={size}
      className={imgCls}
      data-track-id={dataTrackId}
      {...rest}
    />
  );
};

export default XHImage;
